import { render } from "./Box.vue?vue&type=template&id=91feacd2&scoped=true"
import script from "./Box.vue?vue&type=script&lang=ts"
export * from "./Box.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-91feacd2"

export default script
import QForm from 'quasar/src/components/form/QForm.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtnDropdown from 'quasar/src/components/btn-dropdown/QBtnDropdown.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QColor from 'quasar/src/components/color/QColor.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QForm,QSelect,QInput,QBtnDropdown,QList,QItem,QItemSection,QItemLabel,QIcon,QPopupProxy,QColor,QSeparator});qInstall(script, 'directives', {ClosePopup});
